import { Record } from 'immutable';

export default class InvoiceDeliveryTypeRecord extends Record({
  name: undefined,
  type: undefined,
}) {
}
